import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { School } from '../../../models/school.model';
import { ServiceStatus } from '../../shared/service-status.enum';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgClass } from '@angular/common';
import { checkIsWebView } from '../../../../helpers/screen-utils';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { SchoolsService } from '../../shared/schools.service';

@Component({
    selector: 'app-school-selector',
    templateUrl: './school-selector.component.html',
    styleUrl: './school-selector.component.scss',
    imports: [
      MatMenuTrigger,
      MatProgressSpinner,
      MatMenu,
      MatMenuItem,
      NgClass,
      MatRadioGroup,
      MatRadioButton,
      FormsModule
    ]
})
export class SchoolSelectorComponent implements OnInit {
    @Output() schoolChanged = new EventEmitter<School>();
    @Input() ignoreMobileStyling = false;
    // Read-only screens (feed, calendar, directory, groups) list every school a CanSeeAllSchools
    // holder may browse. Leave false anywhere the pick drives a send or message.
    @Input() viewableSchools = false;

    readonly ServiceStatus = ServiceStatus;
    getSchoolServiceStatus: ServiceStatus = ServiceStatus.unset;
    _selectedSchool: School;
    schoolFilterList: School[] = [];
    isWebView: boolean;

    public get selectedSchool(): School {
        return this._selectedSchool;
    }

    public set selectedSchool(value: School) {
        if (this._selectedSchool && this._selectedSchool.Id === value.Id) {
            return;
        }
        // Save selected school and trigger directory data loading
        this.schoolsService.selectSchool(value);
        this._selectedSchool = value;
        this.schoolChanged.emit(value);
    }

  constructor(
    private schoolsService: SchoolsService,
    private snackBar: MatSnackBar
  ) { }

  async ngOnInit() {
    this.checkScreen();
    this.loadSchools();
  }

  @HostListener('window:resize')
  checkScreen() {
    this.isWebView = checkIsWebView() || this.ignoreMobileStyling;
  }

  loadSchools(): void {
    this.getSchoolServiceStatus = ServiceStatus.loading;
    const schools$ = this.viewableSchools
      ? this.schoolsService.getViewableSchoolsForUser()
      : this.schoolsService.getSchoolsForUser();
    schools$.subscribe({
      next: async (result: School[] | null) => {
        this.getSchoolServiceStatus = ServiceStatus.loaded;
        this.schoolFilterList = result ?? [];
        const school = await this.schoolsService.setSchoolFromList(this.viewableSchools && result ? result : undefined);
        if (school) {
          // Find the matching school from the list to ensure object reference equality
          const matchingSchool = this.schoolFilterList.find(s => s.Id === school.Id);
          if (matchingSchool) {
            this.selectedSchool = matchingSchool;
          } else {
            this.selectedSchool = school;
          }
        } else {
          console.warn('No school could be selected');
          // Component will handle null selectedSchool in template
        }
      },
      error: (error) => {
      this.getSchoolServiceStatus = ServiceStatus.error;
      console.error('Failed to load schools:', error);
      this.showErrorSnackBar('Failed to load schools. Please try again later.');
      }
    });
  }

  showErrorSnackBar(message: string) {
    this.snackBar.open(message, 'Close', {
      duration: 4000,
      panelClass: ['snackbar-error']
    });
  }
}
